import { ROUTE_NAMES } from "@root/constants";
import DashboardLayout from "@root/layouts/DashboardLayout";
import { createBrowserRouter, Navigate } from "react-router-dom";
import { FaqProvider } from "@root/context/faq-context";
import { ResourcesProvider } from "@root/context/resources-context";
import { LoginJournalist } from "@root/pages/auth/login/loginJournalist";
import { UserProjectsDashboard } from "@root/pages/dashboard/projectsDashboard";
import CoursesPage from "@root/components/Courses/courses";
import CustomerCenter from "@root/components/customer-center";
import MyLearningDashboard from "@root/components/MyLearningDashboard.tsx";
import Notice from "@root/components/Notice/Index";
import { EmailVerification, Signup, UserSettingProfile } from "@root/pages";
import { UpdateProfile } from "@root/pages/profilesection-journalist/updateprofile/updateprofile";
import { InquiryContextProvider } from "@root/context/inquiries";
import { MyProfile } from "@root/pages/profilesection-journalist/myprofile";
import CourseDetail from "@root/components/Courses/CourseDetail";
import Test from "@root/pages/test";

export const journalistRoutes = createBrowserRouter([
  {
    path: ROUTE_NAMES.HOME,
    element: (
      <InquiryContextProvider>
        <ResourcesProvider>
          <FaqProvider>
            <DashboardLayout />
          </FaqProvider>
        </ResourcesProvider>
      </InquiryContextProvider>
    ),
    children: [
      {
        path: ROUTE_NAMES.HOME,
        element: <Navigate to={ROUTE_NAMES.DASHBOARD} />,
      },
      {
        path: ROUTE_NAMES.DASHBOARD,
        element: <UserProjectsDashboard />,
      },
      {
        path: ROUTE_NAMES.JOURNALIST_COURSES,
        element: <CoursesPage />,
      },
      {
        path: ROUTE_NAMES.JOURNALIST_CUSTOMER_CENTER,
        element: <CustomerCenter />,
      },
      {
        path: ROUTE_NAMES.JOURNALIST_NOTICE,
        element: <Notice />,
      },
      {
        path: ROUTE_NAMES.JOURNALIST_LEARNING,
        element: <MyLearningDashboard />,
      },
      {
        path: ROUTE_NAMES.JOURNALIST_EMAIL_VERIFICATION,
        element: <EmailVerification />,
      },
      {
        path: ROUTE_NAMES.JOURNALIST_PROFILE,
        element: <MyProfile />,
      },
      {
        path: ROUTE_NAMES.JOURNALIST_UPDATE_PROFILE,
        element: <UpdateProfile />,
      },
      {
        path: `${ROUTE_NAMES.JOURNALIST_COURSE_DETAIL}/:id`,
        element: <CourseDetail />,
      },
      {
        path: "/journalist/test",
        element: <Test />,
      },
    ],
  },
]);
